import { render } from "./LabelManagement.vue?vue&type=template&id=2879934e"
import script from "./LabelManagement.vue?vue&type=script&lang=js"
export * from "./LabelManagement.vue?vue&type=script&lang=js"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__